/* eslint-disable complexity */
import React from 'react';
import Text from '../atoms/Text';
import Box from '../atoms/Box';
import Button from '../atoms/Button';
import Alert from '../atoms/icons/Alert';
import Cross from '../atoms/icons/Cross';
import useBanner from '../../hooks/useBanner';
import { string } from 'prop-types';
import { useTranslate } from '../../translate/I18n';
import SanitizedHTML from '../elements/SanitizedHTML';

/**
 * @param {string} name
 * @param {string} title
 * @param {string} description
 * @returns {JSX.Element|null}
 * @constructor
 */
const Banner = ({ name, title, description }) => {
  const { t } = useTranslate(['profile']); // @TODO discuss about atomize this
  const [isDisplayed, hide] = useBanner(name);

  return isDisplayed ? (
    <Box
      display="flex"
      alignItems="flex-start"
      position="relative"
      border="solid 1px"
      backgroundColor="gray50"
      borderColor="gray150"
      borderRadius="8px"
      overflow="hidden"
      mb={3}
      mt={1}
      p={2}
      pl={3}
      pr={0}
      mr={{ _: 0, lg: 2, xl: 0 }}
      flex={{ _: '1', lg: '2', xl: '1' }}>
      <Box m={1}>
        <Box bg="linkedin" position="absolute" top={0} bottom={0} left={0} width="1rem" aria-hidden="true" />
        <Alert color="linkedin" fontSize="23px" />
      </Box>
      <Box ml={2}>
        {title && (
          <Text tag="span" styleName="pLabelPrimary" mr={3}>
            {title}
          </Text>
        )}
        <Text styleName="pPLight">
          <SanitizedHTML tagElement="span" content={description} />
        </Text>
      </Box>
      <Box ml={'auto'}>
        <Button py={0} color="linkedin" styleType="transparent" onClick={() => hide()}>
          {t('components_banner:dismiss')} <Cross style={{ marginLeft: '5px', fontSize: '15px' }} />
        </Button>
      </Box>
    </Box>
  ) : (
    <></>
  );
};

Banner.propTypes = {
  title: string,
  name: string.isRequired,
  description: string.isRequired
};

export default Banner;
